const env = {
  APP_BASE_URL: "https://se.vizybilitydms.net",
  WEBAPI_BASE_URL: "https://api.vizybility.net",
  IDENTITY_API_BASE_URL: "https://identity.vizybility.com",
  IDENTITY_API_VERSION: "v1",
  DEVTOOLS_ENABLED: true,
  APPLICATION_ID: "EF99EE8B-ACD0-47FD-B5E2-5C04BB794C07",
  OWNER: "SE",
  sso: true,
  ssocontinueslogin: true,
  clientId: "247aa0e4-9396-48fb-bec9-728fab26df58",
  redirectUri: "https://se.vizybilitydms.net/",
  STS_SIGNIN_URL: "https://sts.vizybility.net/connect/token",
  STS_CLIENT_ID: "viz-auth-serv-client",
  STS_CLIENT_SECRET:
    "mmAm#GKxXeyz7rtP8htzU8r5y8kdg0YloqlSfH9#Vo9uSbq7zFZaIvvP4EE@Dh",
  STS_SCOPE: "viz-crm-web-api-resource",
  SAS_TOKEN:
    "?sv=2019-02-02&ss=bfqt&srt=sco&sp=rwdlacup&se=2025-01-01T04:59:00Z&st=2020-01-01T05:00:00Z&spr=https&sig=S0KAsoMYqP1AFCfXE%2FDiwHOrSsbuqE8MdrhZOZtQzdo%3D",
  STORAGE_DIRECTORY_NAME: "SE",
  FIREBASE: {
    instance: "DMSDb_se",
  },
  SETTINGS: {
    opportunitiesErpTabTab: { enabled: false },
  },
  MODULES: {
    advertise: { enabled: false },
    expense: { defaultCurrency: "CAD" },
    expenseReportPdfView: { enabled: false },
    inventoryExportPdf: { enabled: false },
    mailchimp: { enabled: true },
  },
  THEME: {
    "@primary-color": "#1DA57A",
    "@link-color": "#1DA57A",
    "@font-size-base": "14px",
    "@font-family": "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  },
};

module.exports = env;
